import { ICoreServiceModel } from "../../../../service/coreCommon/common/model/ICoreServiceModel";
import { CoreRestCRUDService } from "../../../../service/coreCommon/common/rest/CoreRestCRUDService";
import { ILearningConfig } from "../../application/config/ILearningConfig";
import { LearningEnvConfigManager } from "../../application/config/LearningEnvConfigManager";

export abstract class LearningCoreRestCRUDService<ModelType  extends ICoreServiceModel> extends CoreRestCRUDService<ModelType >{
    abstract getEndpoint(): string;

    protected learningConfig: ILearningConfig = LearningEnvConfigManager.getConfig();
}